import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FeaturesInvestment() {
  return <section data-section-id="107638" id="mens-machine" className="text-foreground py-24 !bg-[hsl(20,100%,98%)]">
      <div className="container mx-auto px-4 md:px-8 max-w-screen-xl">
        <div className="grid grid-cols-1 gap-12 !bg-[hsl(20,100%,98%)] md:grid-cols-2 md:gap-16">
          
          <div className="order-1 md:order-2 h-auto">
            <img src="https://trusty-molly.10web.cloud/wp-content/uploads/2026/04/Ontwerp-zonder-titel-7.png" alt="Features investment image" className="w-full object-cover !m-0 h-auto" />
          </div>
          
          <div className="flex flex-col order-2 md:order-1">
            <h2 className="text-3xl md:text-4xl font-default font-semibold uppercase text-foreground mb-4 tracking-tight">
              dit is connected online.<br />
            </h2>
            
            
            <div className="prose text-lg font-default text-muted-foreground leading-relaxed mb-8">
              <p className="mb-4">
                Een online marketing bureau met een eerlijke overtuiging. AI is de toekomst, maar alleen met een menselijke aanpak. Precies waar wij voor staan: geen grote anonieme organisatie, maar een betrokken partner die jouw naam kent en jouw groei serieus neemt.
                <br /><br />
                Wij helpen ondernemers om online te groeien met slimme tools, data-gedreven campagnes en automatiseringen die tijd besparen. Zodat jij je energie kunt steken in wat telt. Je klanten, je product en je ambities
                <br /><br />
                Onze missie is simpel. Elke ondernemer verdient toegang tot de online tools die grote bedrijven al jaren gebruiken. Wij maken dat toegankelijk, persoonlijk en resultaatgericht. Want de toekomst is AI, maar de basis blijft altijd menselijk.
                <br />
              </p>
            </div>

            <Button asChild className="w-full md:w-[240px] rounded-full uppercase font-default font-bold h-auto py-4 bg-primary hover:bg-primary/90 text-primary-foreground transition-all shadow-md hover:shadow-lg">
              <Link to="/team">LEER ONS KENNEN</Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}